import { createStore } from 'vuex'

import * as auth from './modules/auth'
import * as ui from './modules/ui'
import * as agenda from './modules/agenda'
import * as notifications from './modules/notifications'
import * as events from './modules/events'
import * as locations from './modules/locations'
import * as reports from './modules/reports'
import * as org from './modules/org'
import * as tasks from './modules/tasks'
import * as sales from './modules/sales'
import * as quickLinks from './modules/quickLinks'

/**
 * 루트 스토어 조립.
 *
 * 879줄짜리 단일 파일을 도메인별로 나눴다. 다만 Vuex 의 `modules` 옵션은 쓰지 않는다.
 * Vuex 는 namespaced 여부와 관계없이 **모듈 state 를 모듈 이름 아래에 중첩**시키므로
 * 진짜 모듈로 바꾸면 store.state.tasks 가 store.state.tasks.tasks 가 되고
 * 40개 가까운 소비자를 전부 손봐야 한다. 조각을 펼쳐 합치면 동작은 완전히 동일하고
 * 파일만 나뉜다. 테스트가 없는 상태에서 조직화 목적의 변경에 동작 변화를 끼워 넣지 않는다.
 *
 * 새 도메인을 추가할 때: modules/ 에 파일을 만들고 여기 세 줄(import + 3개 스프레드)만 늘린다.
 */
const parts = [auth, ui, agenda, notifications, events, locations, reports, org, tasks, sales, quickLinks]

const merge = (key) => parts.reduce((acc, part) => Object.assign(acc, part[key] || {}), {})

export default createStore({
  state: merge('state'),
  mutations: merge('mutations'),
  actions: merge('actions'),
  getters: merge('getters')
})
